<template>
  <section class="faq container" id="faq">
    <div class="faq__title-wrapper">
      <h2 class="main-title">Частые вопросы</h2>
      <p class="faq__title-wrapper-text">
        Нам часто задают вопросы о ремонте, сроках и процессе. Ниже мы приводим
        список самых популярных из них.
      </p>
    </div>
    <div class="faq-items">
      <AppCollapse title="Можно ли сэкономить на реализации дизайн-проекта?">
        <p>Да, например:</p>
        <ul>
          <li>Заказать только визуализацию.</li>
          <li>Использовать более доступные аналоги материалов из проекта.</li>
          <li>Отказаться от авторского надзора (но риски ошибок возрастут).</li>
        </ul>
      </AppCollapse>
      <AppCollapse title="Вы подбираете мебель и декор?">
        <p>
          Да, в пакете «ДИЗАЙН - ПРОЕКТ» мы полностью комплектуем интерьер: от дивана
          до вазочек.
        </p>
      </AppCollapse>
      <AppCollapse title="Что если нам не понравится концепция?">
        <p>
          Чтобы вы были абсолютно уверены в результате, на старте мы всегда предлагаем несколько базовых вариантов концепции. 
          Если ни один из них вам не откликнется, мы готовы полностью переработать дизайн до трех раз без каких-либо доплат, 
          пока не найдем ваше идеальное решение!
        </p>
      </AppCollapse>
      <AppCollapse title="Как начинается работа?">
        <p>После вашего согласия:</p>
        <ul>
          <li>Подписываем договор.</li>
          <li>Вы вносите 50% оплату проекта.</li>
          <li>Мы выезжаем на замеры — и начинаем творческий процесс!</li>
        </ul>
      </AppCollapse>
      <AppCollapse title="Можно ли увидеть примеры ваших работ?">
        <p>
          Конечно! Вот <router-link to="/projects">портфолио</router-link>. Там
          есть проекты в разных стилях — вы сможете оценить наш подход.
        </p>
      </AppCollapse>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import AppCollapse from '@/components/ui/AppCollapse/Index.vue'

export default defineComponent({
  name: 'Faq',
  components: { AppCollapse },
})
</script>

<style lang="scss" scoped src="./Index.scss" />
